import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
    // Auto-scroll to CTA button on page load
    setTimeout(() => {
      const cta = document.getElementById('cta-comprar');
      if (cta) {
        cta.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }, 300);
  }, []);
  return <SalesPage data-id="element-0" />;
}